<template>
  <div class="columns is-multiline">
    <div class="column">
        <b-field label="Inicio" label-position="inside" >
            <b-datepicker
                v-model="fromDate"
                :first-day-of-week="1"
                :month-names="$moment.months()"
                :day-names="$moment.weekdaysShort()"
                :show-week-number="true"
                placeholder="Click para seleccionar"
                icon="calendar-today">
            </b-datepicker>
        </b-field>
    </div>
    <div class="column">
        <b-field label="Fin" label-position="inside">
            <b-datepicker
                v-model="toDate"
                :first-day-of-week="1"
                :month-names="$moment.months()"
                :day-names="$moment.weekdaysShort()"
                :show-week-number="true"
                placeholder="Click para seleccionar"
                position="is-bottom-left"
                icon="calendar-today">
            </b-datepicker>
        </b-field>
    </div>
    <div class="column is-half">
      <b-field label="Lección" label-position="inside">
          <lessons-select :selected.sync="lessonSelect"/>
      </b-field>
    </div>
  </div>
</template>

<script>
import LessonsSelect from '@/components/LessonSelect'
export default {
  props: {
    selectedLesson: {
      type: Number,
      required: false,
      default: null
    },
    selectedFromDate: {
      type: Date,
      required: false,
      default: null
    },
    selectedToDate: {
      type: Date,
      required: false,
      default: null
    }
  },
  components: {
    LessonsSelect
  },
  data () {
    return {
      lessonSelect: this.selectedLesson,
      fromDate: this.selectedFromDate,
      toDate: this.selectedToDate
    }
  },
  watch: {
    lessonSelect (value) {
      this.$emit('update:selected-lesson', value)
    },
    fromDate (value) {
      this.$emit('update:selected-from-date', value)
    },
    toDate (value) {
      this.$emit('update:selected-to-date', value)
    }
  }
}
</script>
